export const ru = {
    autotargeting: 'Автотаргетинг',
    campaign: 'Кампания',
    clicks: 'Клики',
    'clicks-forecast': 'Прогноз кликов',
    cost: 'Расход, {currency}',
    'cost-forecast': 'Прогноз расхода, {currency}',
    name: 'Группа'
};
